import { useCallback } from "react";

import { useState } from "react";
import type { LayoutChangeEvent } from "react-native";
import { View } from "react-native";
import { type SlideData, Slideshow } from "./SlideShow";

const SlideShowRenderer = ({
	slideshowData,
	itemId,
	handleTracking,
	updateSlideshowDurationInSeconds,
}: {
	slideshowData?: SlideData[];
	itemId?: number;
	handleTracking?: (uri: string, type: "ended" | "started" | "paused") => void;
	updateSlideshowDurationInSeconds: (
		itemId: number,
		durationInSeconds: number,
	) => void;
}) => {
	const [containerWidth, setContainerWidth] = useState(0);

	const onLayout = useCallback(
		(event: LayoutChangeEvent) => {
			if (containerWidth === 0 && event.nativeEvent?.layout?.width) {
				setContainerWidth(event.nativeEvent.layout.width);
			}
		},
		[containerWidth],
	);

	const onDurationsLoaded = useCallback(
		(durationInSeconds: number) => {
			if (itemId) {
				updateSlideshowDurationInSeconds(itemId, durationInSeconds);
			}
		},
		[itemId, updateSlideshowDurationInSeconds],
	);

	if (!slideshowData || slideshowData.length === 0) {
		return null;
	}

	return (
		<View onLayout={onLayout} style={{ flex: 1 }}>
			<Slideshow
				data={slideshowData}
				width={containerWidth}
				loading={containerWidth === 0}
				onDurationLoaded={onDurationsLoaded}
				handleTracking={handleTracking}
			/>
		</View>
	);
};

export default SlideShowRenderer;
